import type { SigningFeatureConfig } from './type';

export const signing: SigningFeatureConfig = {
    isVisibleExplanationOnConfirmation: false,
    otpLengths: [],
    maxCaseMobileOfflineLength: 6,
};
